const LengthUnit = {
  M: "M",
  CM: "CM"
};

export default LengthUnit;
